import { render } from "./avatarCropper.vue?vue&type=template&id=3e227569&scoped=true"
import script from "./avatarCropper.vue?vue&type=script&lang=js"
export * from "./avatarCropper.vue?vue&type=script&lang=js"

import "./avatarCropper.vue?vue&type=style&index=0&id=3e227569&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e227569"]])

export default __exports__